import {
  getGoogleConnectionStatusService,
  getGoogleEventsService,
  includeGoogleEventService,
  excludeGoogleEventService
} from 'Services'
import { createQueryString } from 'Utils/helperFunctions'
import { useState } from 'react'

export default function useCalendarEvents () {
  const [loadingCalendarEventsHook, setLoadingCalendarEventsHook] = useState(false)
  const [connectedCalendarsHook, setConnectedCalendarsHook] = useState([])

  const getConnectedCalendarsHook = async () => {
    try {
      const res = await getGoogleConnectionStatusService()
      const synced = (res?.data?.calendars || []).filter((calendar) => calendar.is_synced)

      setConnectedCalendarsHook(synced)

      return {
        success: true,
        data: synced
      }
    } catch (e) {
      return {
        success: false,
        data: []
      }
    }
  }

  const getGoogleEventsHook = async ({ startDate, endDate }) => {
    try {
      setLoadingCalendarEventsHook(true)

      const query = createQueryString({
        date: startDate && endDate ? `${startDate}:${endDate}` : ''
      })

      const res = await getGoogleEventsService(query)

      return res?.data || []
    } catch (e) {
      return []
    } finally {
      setLoadingCalendarEventsHook(false)
    }
  }

  const includeEventHook = async ({ eventId, hours, notes }) => {
    try {
      setLoadingCalendarEventsHook(true)
      const res = await includeGoogleEventService({ eventId, hours, notes })

      return {
        success: true,
        data: res.data
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || 'An error occurred while including this event in your timesheet. Please try again later.'
      }
    } finally {
      setLoadingCalendarEventsHook(false)
    }
  }

  const excludeEventHook = async ({ eventId }) => {
    try {
      setLoadingCalendarEventsHook(true)
      await excludeGoogleEventService({ eventId })

      return {
        success: true
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || 'An error occurred while removing this event from your timesheet. Please try again later.'
      }
    } finally {
      setLoadingCalendarEventsHook(false)
    }
  }

  return {
    loadingCalendarEventsHook,
    connectedCalendarsHook,
    getConnectedCalendarsHook,
    getGoogleEventsHook,
    includeEventHook,
    excludeEventHook
  }
}
